module.exports = __webpack_public_path__ + "media/34.d856cc7d.ogg";